import type { WorkflowCardProps } from './WorkflowCard';

// Re-export for external use
export type { WorkflowCardProps };

// ASL state type to accent color mapping
export const aslAccentColors: Record<string, string> = {
    task: 'border-l-blue-500',
    choice: 'border-l-blue-800',     // Dark blue for decisions
    pass: 'border-l-slate-400',
    wait: 'border-l-orange-500',
    parallel: 'border-l-gray-900',   // Black for parallel
    map: 'border-l-emerald-500',
    succeed: 'border-l-green-500',
    fail: 'border-l-red-500',
};

// Capability type accent colors (for Task nodes with resources)
export const capabilityAccentColors: Record<string, string> = {
    agent: 'border-l-cyan-600',
    tool: 'border-l-violet-600',
    model: 'border-l-emerald-600',
    workflow: 'border-l-indigo-600',
};

// Sub-workflow accent (distinct from regular task)
export const subWorkflowAccentColor = 'border-l-indigo-600';

